<template>
    <sw-tooltip :content="isCopied ? 'Copiado!' : 'Copiar'">
        <sw-icon
            v-if="!isCopied"
            name="copy"
            class="copy-button"
            @click="handleCopy"
        />
        <sw-icon
            v-else
            name="checkmark"
            class="copy-button copy-button--success"
            @click="handleCopy"
        />
    </sw-tooltip>
</template>

<script setup>
    import { ref } from 'vue';

    const props = defineProps({
        textToCopy: {
            type: String,
            required: true
        },
        duration: {
            type: Number,
            default: 500
        }
    });

    const isCopied = ref(false);

    const handleCopy = async () => {
        try {
            console.log('CopyButton: Tentando copiar texto:', props.textToCopy);
            await navigator.clipboard.writeText(props.textToCopy);

            // Mostrar feedback visual
            isCopied.value = true;
            console.log('CopyButton: Estado alterado para copiado');

            // Voltar ao estado original após duração especificada
            setTimeout(() => {
                isCopied.value = false;
                console.log('CopyButton: Estado voltou ao normal');
            }, props.duration);

            console.log('✅ Texto copiado para clipboard:', props.textToCopy);
        } catch (err) {
            console.error('❌ Erro ao copiar texto:', err);
        }
    };

    // Debug: verificar se o componente está montado
    console.log('CopyButton: Componente montado com textToCopy:', props.textToCopy);
</script>

<style lang="scss">
.copy-button {
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 0.25em;

    &:hover {
        background: var(--backgroundLight, #f8fafc);
    }

    &--success {
        color: var(--colorGreen, #10b981);
    }
}
</style>